import { ResourceHeaders } from '..'
import {
  AppraisalStatusHeader,
  BusinessHeader,
  ChannelHeader,
  DateHeader,
  IdHeader,
  TextHeader,
  VehicleHeader,
  WhatsappHeader,
} from '../../headers'
import { Helpers } from '@/views/datatables/resources/helpers'
import { Person } from '@/entities/persons'

export const headers: ResourceHeaders = [
  {
    ...IdHeader,
    text: 'Nº',
    value: '@',
    options: {
      expandOff: true,
      action: {
        edit: Helpers.linkedModel,
      },
    },
    width: 80,
  },
  { ...BusinessHeader, text: 'Negocio ', value: 'negotiation.inspection.appraisal.deal.lead.pipeline' },
  {
    ...TextHeader,
    text: 'Cliente',
    value: 'negotiation.inspection.appraisal.deal.lead.client.applicantWithRut',
    width: 120,
  },
  { ...ChannelHeader, text: 'Canal', value: 'negotiation.inspection.appraisal.deal.channel' },
  { ...VehicleHeader, text: 'Vehículo', value: 'negotiation.auto' },
  { ...DateHeader, text: 'Fecha de compra ', value: 'created' },
  { ...AppraisalStatusHeader, text: 'Estado de compra', value: '@', width: 140 },
  {
    ...WhatsappHeader,
    text: 'Ejecutivo',
    value: 'negotiation.executive',
    width: 100,
    options: {
      action: {
        color: 'blue',
        always: true,
        icon: 'mdi-whatsapp',
        only: true,
        trigger: (item: Person) => Helpers.contact(item, 'Validator'),
      },
      disabledMissingProperty: ['phone'],
    },
  },
  { ...TextHeader, text: 'Precio autorizado', value: 'authorizePrice', width: 120 },
  { ...TextHeader, text: 'Precio de compra', value: 'amount', width: 120 },
  { ...TextHeader, text: 'Saldo a favor', value: 'marginPositive', width: 120 },
  // { ...TextHeader, text: 'Acreedor de prenda', value: '', width: 120 },
]

export default function (): ResourceHeaders {
  return headers
}
